"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var sortTableData = function (data, column, sortingOrder) {
    return __spreadArray([], __read(data), false).sort(function (a, b) {
        var valueA = column.customSortingFunction
            ? column.customSortingFunction(a)
            : column.accessor(a);
        var valueB = column.customSortingFunction
            ? column.customSortingFunction(b)
            : column.accessor(b);
        return typeof valueA === "number" && typeof valueB === "number"
            ? sortingOrder === "asc"
                ? valueA - valueB
                : valueB - valueA
            : sortingOrder === "asc"
                ? String(valueA).localeCompare(String(valueB))
                : String(valueB).localeCompare(String(valueA));
    });
};
exports.default = sortTableData;
